export enum CustomTrackEvent {
  ON_KLARNA_CREATE_SESSION = 'OnKlarnaCreateSession',
  ON_KLARNA_LOAD_CALLBACK = 'OnKlarnaLoadCallback',
  ON_KLARNA_PAYMENTS_AUTORIZE = 'OnKlarnaPaymentsAuthorize',
  ON_KLARNA_VOUCHERS_PURCHASE_CREATE = 'OnKlarnaVouchersPurchaseCreate',
}
